import { useState, useCallback } from 'react';
import { Form, Input, Toast, Space, Button } from 'antd-mobile';
import { getAuthCode } from "api/api";

/**
 * 手机验证码
 * @param {
 *  item:对应的表单模板
 *  setFormInfo:向传给接口的对象中新增对应表单数据
 * } props 
 * @returns 
 */
export function BpmFormVerificationCode(props) {
  const { postName, label, message, required, time, codePostName, codeLabel, codeMessage } = props.item
  // const { postName, label, message, required, codePostName, codeLabel, codeMessage } = props.item
  // const time = 10
  const { msgTitle, form, setFormInfo } = props;
  const [count, setCount] = useState(time) // 倒计时
  const [loading, setLoading] = useState(false) // 发送验证码按钮loading
  const [disabled, setDisabled] = useState(false) // 发送验证码按钮是否禁用
  const [code, setCode] = useState('')

  // 校验手机号码
  const reg = /^1[3456789]\d{9}$/;

  // 从sessionStorage中获取是否是补贴申请表单
  const SubsidyFormInfoFlag = sessionStorage.getItem("SubsidyFormInfoFlag");


  /** 60s倒计时 */
  const handleCountDown = (seconds = time) => {
    let second = seconds;
    const countDown = () => {
      if (second > 0) {
        second--;
        setCount(second);
      }
      if (second === 0) {
        second = time;
        setCount(second);
        setDisabled(false)
        return;
      }
      setTimeout(countDown, 1000);
    };
    setTimeout(countDown, 1000);
  };

  const myToast = (icon, content) => {
    Toast.show({
      icon,
      content,
    })
  }

  /** 发送验证码的按钮点击事件 */
  const handleSendCode = () => {
    setCode('')
    if (SubsidyFormInfoFlag) {
      sessionStorage.removeItem("SubsidyFormInfoFlag");
    }
    const inputValue = form ? form.getFieldValue(postName) : ''

    if (!reg.test(inputValue)) {
      myToast('fail', '请输入正确的手机号码')
      return
    }
    if (inputValue) {
      setLoading(true)
      const smscontent = `您正在福建省公共就业服务网进行${msgTitle}，验证码为code，请勿向任何人泄漏。`
      const params = {
        phone: inputValue,
        smscontent: smscontent
      };
      getAuthCode(params).then(res => {
        if (res.code === 200) {
          myToast('success', '验证码已发送')
          setCode(res.data.code);
          setDisabled(true)
          handleCountDown()
          // 重新激活表单验证
          form && form.validateFields([codePostName])
        } else {
          myToast('fail', '发送验证码失败，请检查手机号码是否有误')
        }
      }).catch(err => {
        myToast('fail', '请求数据失败')
      }).finally(() => {
        setLoading(false)
      })
    } else {
      myToast('fail', '请输入手机号码')
    }
  }

  /** 更新表单储存的数据 */
  const handleInputChange = (value) => {
    // 重置验证码
    setCode('')
    // 设置表单数据
    setFormInfo(postName, value)
    // 重新激活表单验证
    form && form.validateFields([postName])
    form && form.validateFields([codePostName])
    if (SubsidyFormInfoFlag) {
      sessionStorage.removeItem("SubsidyFormInfoFlag");
    }
  }

  // 手机号的验证规则
  const phoneRule = useCallback((rule, value) => {
    if (value && SubsidyFormInfoFlag) {
      return Promise.resolve()
    } else if (value) {
      if (reg.test(value)) {
        return Promise.resolve()
      } else {
        return Promise.reject('请输入正确的手机号码')
      }
    } else {
      return Promise.reject('请输入手机号码')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SubsidyFormInfoFlag])

  // 验证码验证规则,验证码长度为6位，如果重新获取验证码，则重新验证
  const verificationCodeRule = useCallback((rule, value) => {
    if (value && SubsidyFormInfoFlag) {
      return Promise.resolve()
    } else if (value) {
      if (value.length === 6) {
        if (value === code) {
          return Promise.resolve()
        } else {
          return Promise.reject('验证码错误或已过期，请重新获取')
        }
      } else if (value.length > 6) {
        return Promise.reject('验证码长度不正确')
      }
    } else {
      return Promise.reject('请输入验证码')
    }
  }, [code, SubsidyFormInfoFlag])

  return (
    <>
      <Form.Item
        label={label}
        name={postName}
        required={required}
        rules={[{ validator: phoneRule }]}
        extra={
          <Space>
            <Button
              className='sendCodeBtn'
              loading={loading}
              disabled={disabled}
              onClick={() => handleSendCode()}
            >{disabled ? `${count}s` : '获取验证码'}
            </Button>
          </Space>
        }
      >
        <Input
          onChange={(value) => handleInputChange(value)}
          placeholder={message}
          className='inputTextAlign'
        />
      </Form.Item >
      <Form.Item
        label={codeLabel}
        name={codePostName}
        required={required}
        rules={[{ validator: verificationCodeRule }]}
      >
        <Input
          onChange={value => setFormInfo(codePostName, value)}
          placeholder={codeMessage}
          className='inputTextAlign'
        />
      </Form.Item>
    </>
  )
}